export enum BadgeComponentsEnum {
  WorkInfo = 'WorkInfo',
  Saldo = 'Saldo',
  Note = 'Note',
  Quantity = 'Quantity',
  Expense = 'Expense',
  Material = 'Material',
  Terminate = 'Terminate',
}
